import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // 🔹 دالة الانتقال أو الاسكرول
  const handleScroll = (id) => {
    if (location.pathname !== "/") {
      // لو مش في الصفحة الرئيسية، نرجعها مع الهاش
      navigate(`/#${id}`);
    } else {
      // لو في الصفحة الرئيسية نعمل scroll ناعم
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
    setMenuOpen(false); // إغلاق القائمة في الموبايل
  };

  // 🔹 لو المستخدم رجع للصفحة الرئيسية ومعاه هاش (زي /#about)
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const section = document.getElementById(id);
      if (section) {
        setTimeout(() => {
          section.scrollIntoView({ behavior: "smooth" });
        }, 300);
      }
    }
  }, [location]);

  return (
    <header className="navbar">
      <div className="nav-container">
        {/* الشعار */}
        <div className="logo" onClick={() => navigate("/")}>
          <img
            src="https://res.cloudinary.com/defcamc5x/image/upload/v1760316286/jyjo3ggcopteihukwoau.png"
            alt="شعار المؤسسة"
          />
          <h1>المؤسسة الدولية للاستدامة والتنمية</h1>
        </div>

        {/* القائمة */}
        <nav className={`nav-links ${menuOpen ? "active" : ""}`}>
          <button onClick={() => handleScroll("home")}>الرئيسية</button>
          <button onClick={() => handleScroll("about")}>من نحن</button>
          <button onClick={() => handleScroll("projects")}>مشروعاتنا</button>
          <button onClick={() => handleScroll("news")}>الأخبار</button>
          <button onClick={() => handleScroll("contact")}>تواصل معنا</button>
        </nav>

        {/* أيقونة الموبايل */}
        <div
          className={`menu-icon ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </div>

      {/* 🎨 نفس الـ style اللي عندك */}
      <style>{`
        .navbar {
          width: 100%;
          background: linear-gradient(135deg, #002a6d, #004aad);
          padding: 15px 0;
          position: sticky;
          top: 0;
          z-index: 999;
          box-shadow: 0 4px 10px rgba(0,0,0,0.15);
          direction: rtl;
        }

        .nav-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .logo {
          display: flex;
          align-items: center;
          gap: 12px;
          cursor: pointer;
        }

        .logo img {
          width: 55px;
          height: 55px;
          object-fit: contain;
          filter: drop-shadow(0 2px 5px rgba(0,0,0,0.3));
        }

        .logo h1 {
          color: #b08b56;
          font-size: 1.2rem;
          font-weight: 700;
          letter-spacing: 0.5px;
        }

        .nav-links {
          display: flex;
          gap: 30px;
          align-items: center;
        }

        .nav-links button {
          background: none;
          border: none;
          color: #fff;
          text-decoration: none;
          font-size: 1.05rem;
          font-weight: 500;
          position: relative;
          cursor: pointer;
          transition: color 0.3s ease;
        }

        .nav-links button::after {
          content: "";
          position: absolute;
          bottom: -4px;
          right: 0;
          width: 0%;
          height: 2px;
          background: #b08b56;
          transition: width 0.3s ease;
        }

        .nav-links button:hover {
          color: #b08b56;
        }

        .nav-links button:hover::after {
          width: 100%;
        }

        .menu-icon {
          display: none;
          flex-direction: column;
          justify-content: space-between;
          width: 26px;
          height: 20px;
          cursor: pointer;
        }

        .bar {
          height: 3px;
          background: #fff;
          border-radius: 5px;
          transition: all 0.4s ease;
        }

        .menu-icon.open .bar:nth-child(1) {
          transform: translateY(8px) rotate(45deg);
        }
        .menu-icon.open .bar:nth-child(2) {
          opacity: 0;
        }
        .menu-icon.open .bar:nth-child(3) {
          transform: translateY(-8px) rotate(-45deg);
        }

        @media (max-width: 900px) {
          .nav-links {
            position: absolute;
            top: 70px;
            right: 0;
            background: rgba(0, 42, 109, 0.97);
            flex-direction: column;
            align-items: center;
            width: 100%;
            padding: 20px 0;
            gap: 20px;
            border-top: 2px solid #b08b56;
            opacity: 0;
            transform: translateY(-20px);
            pointer-events: none;
            transition: all 0.4s ease;
          }

          .nav-links.active {
            opacity: 1;
            transform: translateY(0);
            pointer-events: all;
          }

          .menu-icon {
            display: flex;
          }

          .logo h1 {
            font-size: 1rem;
          }
        }

        @media (max-width: 480px) {
          .logo img {
            width: 45px;
            height: 45px;
          }

          .logo h1 {
            font-size: 0.9rem;
          }

          .nav-links button {
            font-size: 1rem;
          }
        }
      `}</style>
    </header>
  );
};

export default Navbar;
